// @ts-ignore
import { SettingsContext } from "contexts/settingsContext";
// @ts-ignore
import { useCallback, useContext, useEffect, useState } from "react";
import useSettings from './useSettings'

// @ts-ignore
import Decimal from "decimal.js";
// @ts-ignore
import TelegramProvider, { useTelegram } from "contexts/TelegramContext";
import useAxios from "./useAxios";
import { useQuery } from "@tanstack/react-query";

const useUserBalances = () => {
    const { settings } = useSettings();
    const { callApi } = useAxios();

    const { data: userBalance } = useQuery({
        enabled: !!settings?.token,
        queryKey: ['UserBalance', settings?.token],

        queryFn: async () => {
            if (!settings?.token) return;
            try {
                const userData = await callApi('get', '/user/user-balance');
                const TONBalance = userData?.userBalances?.find((/** @type {{ token: string; }} */ e) => e.token === 'TON')?.balance ?? 0;
                const COMBalance = userData?.userBalances?.find((/** @type {{ token: string; }} */ e) => e.token === 'COM')?.balance ?? 0;
                const POWERBalance = userData?.userBalances?.find((/** @type {{ token: string; }} */ e) => e.token === 'POWER')?.balance ?? 0;

                return {
                    userBalances: userData,
                    TONBalance,
                    COMBalance,
                    POWERBalance,
                };
            } catch (error) {
                console.error('Error fetching user data:', error);
                return null;
            }
        },
        staleTime: 1000 * 60 * 5,
    });

    return {
        ...userBalance,
        TONBalance: userBalance?.TONBalance ?? 0,
        CATBalance: userBalance?.CATBalance ?? 0,
        GEMBalance: userBalance?.GEMBalance ?? 0,
    };
};

export default useUserBalances;
